export const BaseURL = process.env.REACT_APP_API_BASE_URL;
export const ContestToken = '50319ac67e68f7ecc585114224f8e68895476659e355cd03fd87861507af37e6';

export const isMock = () => {
    return (window as any)?.NaviScripts?.isBuild;
};
